import { LineItem } from '@src/Component/LineItem';

import { subscribeSelector } from '@src/Service/subscribeSelector';
import { getPriceBreakdown, getLineItems, syncFrom } from '@src/Redux/Module/Cart';

import { cloneDeep } from 'lodash';

/**
 * @typedef {import('@src/Redux/Store/OnlineStore').OlsStore} OlsStore
 *
 * @typedef {import('@src/Repository/CartRepository').CartRepository} CartRepository
 *
 * @typedef {import('@src/Service/TemplateFactory').TemplateFactory} TemplateFactory
 * @typedef {import('@src/Service/LocationProxy').LocationProxy} LocationProxy
 *
 * @typedef {import('@src/Dto/Response/Api/PriceBreakdown').PriceBreakdown} PriceBreakdown
 * @typedef {import('@src/Dto/Response/Api/LineItem').LineItem} LineItemInfo
 */
export class CartReview {
    /**
     *
     * @param {JQuery} $element
     * @param {OlsStore} store
     * @param {CartRepository} cartRepository
     * @param {TemplateFactory} templateFactory
     * @param {LocationProxy} location
     */
    constructor($element, store, cartRepository, templateFactory, location) {
        this._store = store;
        this._$element = $element;
        this._cartRepository = cartRepository;
        this._templateFactory = templateFactory;
        this._location = location;

        subscribeSelector(this._store, getPriceBreakdown, this._updateSubtotalLine.bind(this));
        subscribeSelector(this._store, getLineItems, this._regenerateLineItems.bind(this));

        // Clear All Clicked
        $('.clear-cart').on('click', () => {
            this._store.dispatch(syncFrom(
                this._cartRepository.resetCart()
                    .catch(() => this._location.assign('/error.php')),
            )).then(() => {
                $('#cart .cart-error').remove();
            });
        });

        this._regenerateLineItems(getLineItems(this._store.getState()));
    }

    /**
     * @param {LineItemInfo[]} lineItems
     * @private
     */
    _regenerateLineItems(lineItems) {
        if (lineItems?.length === 0 || !lineItems) {
            return;
        }

        // Prepare new line item components for the incoming cart state.
        const $lineItems = cloneDeep(lineItems)
            .sort((lhs, rhs) => (lhs.sellName > rhs.sellName ? 1 : 0))
            .map((lineItem) => (
                new LineItem(
                    lineItem,
                    this._store,
                    this._cartRepository,
                    this._templateFactory,
                    this._location,
                ).$element
            ));

        // Swap old and new line item lists.
        this._$element.find('.line-items')
            .empty()
            .append($lineItems);
    }

    /**
     * @param {PriceBreakdown} totals
     *
     * @private
     */
    _updateSubtotalLine(totals) {
        $('.subtotal .price .value').text(totals?.subtotal);
    }
}
